/**
 * Tour step definitions.
 * target — CSS selector matching a real DOM element.
 * position — 'auto' | 'right' | 'left' | 'above' | 'below'
 */

export const SEEKER_TOUR_STEPS = [
  {
    target: '.sidebar-logo',
    icon: '👋',
    title: 'Welcome to JobLinked AI!',
    body: "You're on your dashboard. This sidebar is your main navigation — everything you need is right here.",
    position: 'right',
  },
  {
    target: '[data-tour="cv-upload"]',
    icon: '📄',
    title: 'Upload your CV first',
    body: 'Start by uploading your CV. Our AI reads it to match you with the right jobs and auto-fill applications.',
    position: 'below',
  },
  {
    target: '.sidebar-link.active, .sidebar-link:first-of-type',
    icon: '📊',
    title: 'Your overview',
    body: 'This is your home base — see your stats, recent applications, and CV status at a glance.',
    position: 'right',
  },
  {
    target: '[data-tour="matched-jobs"]',
    icon: '🎯',
    title: 'Your matched jobs',
    body: 'Once your CV is uploaded, AI matches you with jobs that fit your skills. Check here daily for new matches.',
    position: 'right',
  },
  {
    target: '[data-tour="browse-jobs"]',
    icon: '🔍',
    title: 'Browse all jobs',
    body: 'Search and filter all active job listings posted by South African recruiters directly on the platform.',
    position: 'right',
  },
  {
    target: '[data-tour="applications"]',
    icon: '📋',
    title: 'Track your applications',
    body: 'Every application you submit is tracked here — see status updates from recruiters in real time.',
    position: 'right',
  },
  {
    target: '[data-tour="auto-apply"]',
    icon: '⚡',
    title: 'Auto-Apply',
    body: 'Let AI apply to matching jobs on your behalf. Available on the Pro and Premium plans.',
    position: 'right',
  },
  {
    target: '[data-tour="my-profile"]',
    icon: '👤',
    title: 'Complete your profile',
    body: 'A complete profile improves your AI match score. Add your skills, experience, and job preferences.',
    position: 'right',
  },
  {
    target: '[data-tour="my-plan"]',
    icon: '👑',
    title: 'Upgrade your plan',
    body: "You're on the Free plan. Upgrade to Pro or Premium to unlock AI matching, auto-apply, and more.",
    position: 'right',
  },
];

export const RECRUITER_TOUR_STEPS = [
  {
    target: '.sidebar-logo',
    icon: '👋',
    title: 'Welcome to JobLinked AI!',
    body: "You're on your recruiter dashboard. Use the sidebar to navigate — post jobs, find candidates, and manage everything from here.",
    position: 'right',
  },
  {
    target: '[data-tour="post-job"]',
    icon: '📝',
    title: 'Post your first job',
    body: 'Click here to create a job listing. Our AI will immediately start matching qualified candidates to it.',
    position: 'right',
  },
  {
    target: '[data-tour="dashboard"]',
    icon: '📊',
    title: 'Your dashboard',
    body: 'See all your active job postings, application counts, and hiring stats at a glance.',
    position: 'right',
  },
  {
    target: '[data-tour="find-candidates"]',
    icon: '🔍',
    title: 'Find candidates',
    body: 'Search our database of job seekers by skills, location, and experience. Reach out directly via messages.',
    position: 'right',
  },
  {
    target: '[data-tour="analytics"]',
    icon: '📈',
    title: 'Hiring analytics',
    body: 'Track your hiring funnel — applications, interviews, and hires. Available on the Professional plan.',
    position: 'right',
  },
  {
    target: '[data-tour="company-profile"]',
    icon: '🏢',
    title: 'Set up your company profile',
    body: 'A complete company profile builds trust with candidates. Add your logo, culture, benefits, and social links.',
    position: 'right',
  },
  {
    target: '[data-tour="pricing"]',
    icon: '👑',
    title: 'Upgrade your plan',
    body: "You're on the Starter plan (1 job posting). Upgrade to Professional or Business to post more jobs and unlock AI screening.",
    position: 'right',
  },
];
